import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["selected", "productLevel", "disabled", "onClick", "apiName"];
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Small } from 'foundations-components/transitional/components/Small';
import styled, { css } from 'foundations-theming/utils';
import { trellisBreakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { useHighestPossibleMonthlyPrice } from '../../../hooks/useBulkPurchaseOptions';
import { useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectableBox = styled(UISelectableBox).withConfig({
  displayName: "ProductLevelSelectionButton__SelectableBox",
  componentId: "xq43pg-0"
})(["&&&{width:100%;border-radius:0;&:hover{z-index:8;}", ";", ";}"], ({
  disabled
}) => disabled && css(["border-color:", " !important;font-weight:400;"], GREAT_WHITE), ({
  selected
}) => selected && css(["background-color:inherit;z-index:7;"]));
const SelectionButtonWrapper = styled.div.withConfig({
  displayName: "ProductLevelSelectionButton__SelectionButtonWrapper",
  componentId: "xq43pg-1"
})(({
  theme
}) => {
  return {
    width: '33.333333%',
    marginBlock: theme.space[0],
    marginInline: theme.space[50],
    [trellisBreakpoint.phone]: {
      display: 'block',
      width: '100%',
      marginBlock: theme.space[0],
      marginInline: theme.space[0]
    }
  };
});
const ProductLevelSelectionButton = _ref => {
  let {
      selected,
      productLevel,
      disabled,
      onClick,
      apiName
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const currencyCode = useDisplayedCurrencyCode();
  const {
    highestPossibleMonthlyPrice: price,
    loading: priceLoading
  } = useHighestPossibleMonthlyPrice({
    apiName
  });
  return /*#__PURE__*/_jsx(SelectionButtonWrapper, {
    children: /*#__PURE__*/_jsx(SelectableBox, Object.assign({
      flush: true,
      type: "checkbox",
      selectionMarkLocation: "top-right",
      onClick: onClick,
      selected: selected,
      disabled: disabled,
      "data-selenium-class": `${productLevel}-product-level-button`,
      "data-selected": selected,
      "data-disabled": disabled
    }, rest, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center",
        marginBlock: "400",
        paddingInlineStart: "300",
        maxBlockSize: "36px",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `planBuilder.productLevel.${productLevel}`
          })
        }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: priceLoading,
          heights: [20],
          widths: [50],
          children: /*#__PURE__*/_jsx(Small, {
            typography: "body-125",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "planBuilder.priceDisplay.pricePerMonth",
              options: {
                price: /*#__PURE__*/_jsx(PriceDisplay, {
                  price: price,
                  currencyCode: currencyCode
                })
              }
            })
          })
        })]
      })
    }))
  });
};
export default ProductLevelSelectionButton;